import { Route, Routes } from "react-router-dom";

import EntityCreateScreen from "screens/App/CRM/Entity/EntityCreateScreen";
import EntityDetailScreen from "screens/App/CRM/Entity/EntityDetailScreen";
import EntityEditScreen from "screens/App/CRM/Entity/EntityEditScreen";
import EditEntityPlanScreen from "screens/App/CRM/Entity/EditEntityPlanScreen";
import RegisterAccountEntityScreen from "screens/App/CRM/Entity/RegisterAccountEntityScreen";
import EntityListScreen from "screens/App/CRM/Entity/EntityListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const EntityRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<EntityCreateScreen />} />
      <Route path="list" element={<EntityListScreen />} />
      <Route path=":id">
        <Route path=":detail" element={<EntityDetailScreen />} />
        <Route path="edit" element={<EntityEditScreen />} />
        <Route path="edit-plan" element={<EditEntityPlanScreen />} />
      </Route>
      <Route path="register" element={<RegisterAccountEntityScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default EntityRouter;
